import { useState } from 'react'
import Breadcrumbs from '@byma/shared/components/Breadcrumbs'
import EventForm from 'components/EventForm'
import Layout from 'components/Layout'
import useAuth from '@byma/shared/hooks/useAuth'
import useToastContext from "@byma/shared/hooks/useToastContext";
import fetcher from '@byma/shared/helpers/fetcher'
import { useRouter } from 'next/router'

export default function NewEvent() {
    const session = useAuth()
    const { token, user: currentUser } = session
    const addToast = useToastContext()
    const router = useRouter()
    const [ isLoading, setIsLoading ] = useState(false)


    async function handleCreate(values) {
        setIsLoading(true)
        try {
            await fetcher('/api/parties/create', {
                body: JSON.stringify(values),
                method: 'POST',
            }, token)
            addToast('Evento criado com sucesso')
            router.push('/events')
        } catch (e) {
            if (e?.info?.message === 'ErrorFindingPartner') {
                addToast('Equipe inválida', 'error')
            } else if (e?.info?.message === 'InvalidContract') {
                addToast('Equipe com contrato inválido', 'error')
            } else {
                addToast('Erro ao criar evento', 'error')
            }
            console.log('error', e.info?.message)
            setIsLoading(false)
        }
    }

    const breadcrumbPaths = [
        { label: 'Eventos', url: `/events` },
        { label: 'Novo evento', url: `/events/new` },
    ]

    return (
        <Layout {...{ session }}>
            <div className="p-3">
                <div className="mb-6">
                    <Breadcrumbs paths={breadcrumbPaths} />
                </div>
                <EventForm onSubmit={handleCreate} {...{isLoading}}/>
            </div>
        </Layout>
    )
}
